// Mobile hero slider — adds dot indicators to the homepage image-gallery
// when it's rendered as a horizontal scroll-snap slider on mobile.
(function () {
  if (!document.body || !document.body.classList.contains('template-index')) return;

  function init() {
    var galleries = document.querySelectorAll('.template-index .section-gallery');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var container = gallery.querySelector('.section-gallery__container');
      if (!container) return;
      var slides = container.querySelectorAll('.section-gallery__item-wrapper');
      if (slides.length < 2) return;
      if (gallery.querySelector('.claro-hero-dots')) return;

      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'claro-hero-dots';
      var dots = [];
      slides.forEach(function (slide, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'claro-hero-dots__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.addEventListener('click', function () {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(btn);
        dots.push(btn);
      });
      gallery.appendChild(dotsWrap);

      var ticking = false;
      function updateActive() {
        var center = container.scrollLeft + container.clientWidth / 2;
        var bestIndex = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var dist = Math.abs(slideCenter - center);
          if (dist < bestDist) { bestDist = dist; bestIndex = i; }
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === bestIndex);
        });
        ticking = false;
      }

      container.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateActive);
          ticking = true;
        }
      }, { passive: true });
      window.addEventListener('resize', updateActive);
      updateActive();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
